export const iconFontAwesomeWeatherSun = (
	<i className="fa-solid fa-sun"></i>
);
